import { Tag, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { displayMessage } from '../../../helpers/messages';

export const clientGridColumns = (handleEdit) => [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: 'Cor',
    dataIndex: 'color',
    key: 'color',
    width: 60,
    render: (color) => (
      <div
        style={{
          width: 30,
          height: 30,
          backgroundColor: color || '#1890ff',
          borderRadius: '50%',
          border: '2px solid #d9d9d9',
          margin: '0 auto',
        }}
        title={color || '#1890ff'}
      />
    ),
  },
  {
    title: displayMessage('COMPANY_NAME'),
    dataIndex: 'company_name',
    key: 'company_name',
    sorter: (a, b) => (a.company_name || '').localeCompare(b.company_name || ''),
  },
  {
    title: displayMessage('COMPANY_DOCUMENT'),
    dataIndex: 'company_document',
    key: 'company_document',
    width: 180,
    sorter: (a, b) => (a.company_document || '').localeCompare(b.company_document || ''),
  },
  {
    title: displayMessage('NICKNAME'),
    dataIndex: 'nickname',
    key: 'nickname',
    sorter: (a, b) => (a.nickname || '').localeCompare(b.nickname || ''),
  },
  {
    title: displayMessage('STATE'),
    dataIndex: 'state',
    key: 'state',
    width: 80,
    sorter: (a, b) => (a.state || '').localeCompare(b.state || ''),
  },
  {
    title: displayMessage('CITY'),
    dataIndex: 'city',
    key: 'city',
    sorter: (a, b) => (a.city || '').localeCompare(b.city || ''),
  },
  {
    title: displayMessage('STATUS'),
    dataIndex: 'is_active',
    key: 'is_active',
    width: 120,
    render: (is_active) => (
      <Tag color={is_active ? 'green' : 'red'}>
        {is_active ? displayMessage('ACTIVE') : displayMessage('INACTIVE')}
      </Tag>
    ),
    sorter: (a, b) => (a.is_active === b.is_active ? 0 : a.is_active ? -1 : 1),
  },
  {
    title: displayMessage('ACTIONS'),
    key: 'actions',
    width: 100,
    render: (_, record) => (
      <Button
        type="primary"
        icon={<EditOutlined />}
        size="small"
        onClick={() => handleEdit(record)}
      >
        {displayMessage('EDIT')}
      </Button>
    ),
  },
];



